<template>
    <div class="page" ref="page">
        <div ref="loginBg">
            <div class="login">
                <img src="@/assets/new/login_bg.png" alt="">
            </div>
            <div class="h5-form">
                <div class="form">
                    <van-field v-model="loginData.requestId" placeholder="请输入设备号" label-align="left">
                        <template #left-icon>
                            <img src="@/assets/new/3.png" alt="">
                        </template>
                        <template #right-icon>
                            <img src="@/assets/new/5.png" alt="" @click="socan">
                        </template>
                    </van-field>
                </div>
                <div class="form">
                    <van-field v-model="loginData.userPhone" placeholder="请输入您的手机号码" label-align="left">
                        <template #left-icon>
                            <img src="@/assets/new/4.png" alt="">
                        </template>
                    </van-field>
                </div>
                <div class="form code">
                    <van-field v-model="loginData.smsCode" placeholder="请输入验证码" label-align="left">
                        <template #left-icon>
                            <img src="@/assets/new/2.png" alt="">
                        </template>
                    </van-field>
                    <van-button v-if="!countdown" size="small" type="primary" @click="getCode()">发送验证码</van-button>
                    <van-button v-if="countdown" size="small" type="primary" disabled>{{ count }}S后重新获取</van-button>
                </div>
                <van-button size="small" type="primary" @click="toActive()" class="sumbitBtn">激 活 UFI</van-button>
            </div>
            <div class="prompt" :style="{ 'margin-top': height + 'px' }">
                <div class="prompt-top">温馨提示</div>
                <div class="prompt-name">请在收到设备后尽快开通，以免优惠失效</div>
                <div class="prompt-name">开通成功后，套餐长期有效，不使用不扣费</div>
                <div class="prompt-name">开通成功后再次登录，会直接进入设备管理系统</div>
            </div>
        </div>
        <div class="footer" :style="{ 'margin-top': h_top + 'px' }"> 在线客服时间：9:00 - 23.00</div>
    </div>
</template>
<script>
import { wxRequest } from '@/api/user'
import { Toast, Dialog } from 'vant'
import wx from 'weixin-js-sdk';
export default {
    data() {
        return {
            countdown: false,
            h_top: 0,
            count: 0,
            height: null,
            loginData: {
                requestId: '',//设备号
                userPhone: '',//手机号
                smsCode: '',//验证码
                isLogin: '',
                code: '',
                isOpenid: 0
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.height = this.$refs.page.clientHeight - (this.$refs.page.clientHeight - 240)
            this.h_top = this.$refs.page.clientHeight - (this.$refs.page.clientHeight - 60)
        })
    },
    async created() {
        var source = this.getQueryVariable("source") ? this.getQueryVariable("source") : process.env.VUE_APP_APPID;
        var appid = source ? source : process.env.VUE_APP_APPID;
        await wxRequest("sim/get/pay/state", { iccid: localStorage.getItem("iccid") }, "post").then((res) => {
            localStorage.setItem("buyCode", res.data.code);
            if (res.data.code == 200) {
                localStorage.setItem("leshuaPay", 1);
            } else {
                localStorage.setItem("leshuaPay", 2);
            }
        });
        localStorage.setItem("appid", appid);
        localStorage.setItem("isHeadquarterAppid", true);
        this.$store.commit("setIsHeadquarterAppid", "true");
        if (this.$route.query.iccid) {
            this.loginData.requestId = this.$route.query.iccid;
        }
        var redirectUrl = window.location.href;
        var index = redirectUrl.indexOf("code");
        redirectUrl = encodeURIComponent(redirectUrl);
        if (index < 0) {
            this.loginData.code = "1s";
            //  window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_base#wechat_redirect`;
        } else {
            var search = window.location.search;
            console.log("search", search);
            var startIndex = search.indexOf("code");
            var endIndex = search.indexOf("&", startIndex);
            var str = search.slice(startIndex, endIndex);
            var code = str.slice(str.indexOf("=") + 1);
            this.loginData.code = code;
            if (this.$route.query.iccid) {
                this.loginData.requestId = this.$route.query.iccid;
            } else {
                this.loginData.requestId = localStorage.getItem("recordLoginText");
            }
        }
    },
    methods: {
        toActive() {
            let recordLoginText = this.loginData.requestId; //存放用户登录时输入的文本，将用于首页显示
            wxRequest('/she/bind', this.loginData, 'get').then(res => {
                if (res.data.code === '200') {
                    let record = res.data.data;
                    let iccid = record.iccid;
                    if (record.titleMap) {
                        localStorage.setItem("wxTitle", record.titleMap.title);
                        localStorage.setItem("wxText", record.titleMap.context);
                        localStorage.setItem("wxUrls", record.titleMap.urls);
                    } else {
                        localStorage.setItem("wxTitle", '');
                        localStorage.setItem("wxText", '');
                        localStorage.setItem("wxUrls", '');
                    }
                    localStorage.setItem("showYu", record.showYu); //弹窗图片

                    localStorage.setItem('isNewPage', record.isNewPage);
                    this.$store.state.isNewPage = record.isNewPage;
                    localStorage.setItem('newHomeImg', record.newHomeImg);
                    localStorage.setItem('newHomeImg2', record.newHomeImg2);
                    localStorage.setItem('newHomeUrl', record.newHomeUrl);
                    localStorage.setItem("mobile", record.mobile);
                    localStorage.setItem("isBindPhone", record.isBindPhone);
                    localStorage.setItem("supplierTypeName", record.supplierTypeName);
                    localStorage.setItem("wxHeadImg", record.wxHeadImg);
                    localStorage.setItem("wxNickName", record.wxNickName);
                    localStorage.setItem("recordLoginText", recordLoginText);
                    localStorage.setItem("supplierName", record.supplierName);
                    localStorage.setItem("iccid", iccid);
                    localStorage.setItem("intoNo", record.intoNo);
                    localStorage.setItem("phoneNo", record.userPhone);
                    localStorage.setItem("userPhone", record.userPhone);
                    localStorage.setItem("openId", record.openId);
                    localStorage.setItem("agentId", record.agentId);
                    localStorage.setItem("flowRatePool", record.flowRatePool);
                    this.$store.state.recordLoginText = recordLoginText;
                    this.$store.state.supplierCode = res.data.data.supplierCode;
                    this.$store.state.iccid = iccid;
                    this.$store.state.flowRatePool = res.data.data.flowRatePool;
                    this.$store.state.intoNo = record.intoNo;
                    this.setAutoCompleteData("iccidList", recordLoginText, 10);
                    if (record.isToYuCun != 1) {
                        this.$router.replace("/user/openPrice");
                    } else {
                        // if (record.isNewPage == 0) {
                        //     this.$router.replace('/user/home');
                        // } else if (record.isNewPage == 1) {
                        //     this.$router.replace('/userNew/home');
                        // } else if (record.isNewPage == 2) {
                        //     this.$router.replace('/user/homeNew');
                        // } else if (record.isNewPage == 3) {
                        //     this.$router.replace('/new/home');
                        // }
                        this.$router.replace('/new/home');
                    }
                } else {
                    Toast.fail(res.data.message)
                }
            })
        },
        getCode() {
            if (!(/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this.loginData.userPhone))) {
                Toast.fail('请填写正确的手机号')
                return
            }
            wxRequest('/bindPhone/sms/code', { userPhone: this.loginData.userPhone }, 'post').then(res => {
                if (res.data.code === '200') {
                    const TIME_COUNT = 59
                    if (!this.timer) {
                        this.count = TIME_COUNT
                        this.countdown = false
                        this.timer = setInterval(() => {
                            if (this.count > 0) {
                                this.count--
                                this.countdown = true
                            } else {
                                this.countdown = false
                                clearInterval(this.timer)
                                this.timer = null
                            }
                        }, 1000)
                    }
                    Toast.success('发送成功')
                } else {
                    Toast.fail(res.data.message)
                }
            })
        },

        socan() {
            this.doconfig();
            let that = this;
            wx.scanQRCode({
                needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                //scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
                success: function (res) {
                    var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
                    if (result.indexOf("http") != -1 || result.indexOf("https") != -1) {
                        window.location.href = result;
                    } else {
                        that.loginData.requestId = result;
                    }
                }
            });
        },
        doconfig() {
            wxRequest('sim/getWxConfig2', {}, 'post').then(res => { // 不管是自己写的方法还是后台给的接口方法都可以，只要这个方法有这个wx.config需要的参数
                wx.config({
                    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    appId: res.data.data.appId, // 必填，公众号的唯一标识
                    timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
                    nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
                    signature: res.data.data.signature, // 必填，签名
                    jsApiList: ["scanQRCode",
                        "updateAppMessageShareData",
                        "updateTimelineShareData",], // 必填，需要使用的JS接口列表
                    openTagList: ['wx-open-launch-weapp'], // 跳转小程序要用到的标签
                    success(res) {
                        console.log(res, 11)
                        // Toast.fail(res.data.message);
                    },
                    fail(res) {
                        console.log(res, 12)
                        // Toast.fail(res.data.message);
                    }
                })
            })
            wx.ready(function () {
                // this.isAudit = true
                console.log('准备好了~~~');
            })
            wx.error(function (res) {
                console.log(res, 12)
                // Toast.fail(res.data.message);
            })
        },
        //获取url参数
        getQueryVariable(variable) {
            var query = window.location.search.substring(1);
            var vars = query.split("&");
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");
                if (pair[0] == variable) {
                    return pair[1];
                }
            }
            return false;
        },

    }
}
</script>
<style lang="less" scoped>
.page {
    /* height: 100%; */
    width: 100%;
    background: #FFEFE1;
    position: relative;
    padding-bottom: 14px;
    min-height: calc(100% - 14px);

    .login {
        width: 100%;

        img {
            width: 100%;
            height: auto;
        }
    }

    .prompt {
        padding: 18px;
        width: 80%;
        background: #fff;
        border-radius: 10px;
        margin: auto;

        .prompt-top {
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 20px;
            padding-left: 22px;
            background: url('../../assets/new/icon2.png') no-repeat left center;
            background-size: 17px 12px;
        }

        .prompt-name {
            color: #646668;
            font-size: 12px;
            line-height: 22px;
            font-family: PingFangSC-Regular, PingFang SC;
        }
    }


    .h5-form {
        width: 82%;
        margin: auto;
        background: #fff;
        border-radius: 10px;
        padding: 34px 16px 48px;
        position: absolute;
        top: 190px;
        left: 0;
        right: 0;

        .form {
            margin-bottom: 12px;
        }

        .code {
            display: flex;

            .van-button {
                height: 48px;
                line-height: 48px;
                border-radius: 26px;
                width: 200px;
                margin-left: 10px;
                font-size: 14px;
                background-color: #C47A3A;
                border-color: #C47A3A;
            }
        }

        .van-cell {
            background-color: #F7F7F7;
            height: 48px;
            border-radius: 26px;
            padding: 0 16px;
            line-height: 48px;

            ::v-deep .van-field__left-icon {
                text-align: center;

                img {
                    width: 50%;
                    height: auto;
                    vertical-align: middle;
                }
            }

            ::v-deep .van-field__right-icon {
                text-align: center;

                img {
                    width: 50%;
                    height: auto;
                    vertical-align: middle;
                }
            }
        }

        .sumbitBtn {
            height: 48px;
            line-height: 48px;
            border-radius: 26px;
            background-color: #C47A3A;
            border-color: #C47A3A;
            margin-top: 22px;
            width: 100%;
            font-family: PingFangSC, PingFang SC;
            font-size: 18px;
        }
    }

    .footer {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #908B85;
        line-height: 20px;
        text-align: left;
        font-style: normal;
        background: url('~@/assets/new/1.png') no-repeat 25% center;
        text-align: center;
        background-size: 19px 19px;
        margin-top: 450px;
        padding-left: 22px;
    }
}
</style>
